var LOGIC=LOGIC||{};LOGIC.sevenSegment=(function(){/**
 * 7-segment DRO digits as SVG paths (screens/bolt-circle.html).
 *
 * Format: sign slot + 3 integer digits + "." + 3 decimals → 7 cells, dot between cell 3 and 4.
 * Leading zeros are blank, the minus sign hugs the first digit, unlit segments are drawn as faint "ghost 8s".
 *
 * Usage (per axis row, 192 × 40 viewBox):
 *   const s = sevenSegmentPaths(-34.641);
 *   <g transform="skewX(-7) translate(5 0)">
 *     <path d={s.off} fill={axisColour} fillOpacity={0.07} />
 *     <path d={s.lit} fill={axisColour} />
 *     <circle cx={s.dot.cx} cy={s.dot.cy} r={s.dot.r} fill={axisColour} />
 *   </g>
 *   …with CSS filter: drop-shadow(0 0 4px <axisColour at 55%>) on the svg.
 * Axis colours: X #5cc8ff, Y #ffb547.
 */

const SEGMENTS = {
  '0': 'abcdef', '1': 'bc', '2': 'abdeg', '3': 'abcdg', '4': 'bcfg',
  '5': 'acdfg', '6': 'acdefg', '7': 'abc', '8': 'abcdefg', '9': 'abcdfg', '-': 'g', ' ': '',
};

/** Value → 7 display cells, e.g. -34.641 → [' ', '-', '3', '4', '6', '4', '1']. */
function droCells(value) {
  const r = Math.abs(value) < 0.0005 ? 0 : value;
  const [ip, dp] = Math.abs(r).toFixed(3).split('.');
  const ints = ip.length > 3 ? '999' : ip.padStart(3, ' ');
  const cells = [' ', ...ints, ...dp];
  if (r < 0) { let fi = 1; while (cells[fi] === ' ') fi++; cells[fi - 1] = '-'; }
  return cells;
}

function segmentPolys(x0, y0, w, h, t) {
  const hx = (x1, x2, y) => [[x1, y], [x1 + t / 2, y - t / 2], [x2 - t / 2, y - t / 2], [x2, y], [x2 - t / 2, y + t / 2], [x1 + t / 2, y + t / 2]];
  const vx = (x, y1, y2) => [[x, y1], [x + t / 2, y1 + t / 2], [x + t / 2, y2 - t / 2], [x, y2], [x - t / 2, y2 - t / 2], [x - t / 2, y1 + t / 2]];
  const g = t * 0.32, m = y0 + h / 2, L = x0 + t / 2, R = x0 + w - t / 2, T = y0 + t / 2, B = y0 + h - t / 2;
  return { a: hx(L + g, R - g, T), g: hx(L + g, R - g, m), d: hx(L + g, R - g, B), f: vx(L, T + g, m - g), b: vx(R, T + g, m - g), e: vx(L, m + g, B - g), c: vx(R, m + g, B - g) };
}

const F = (v) => (Math.round(v * 100) / 100).toString();
const poly = (pts) => 'M' + pts.map((q) => F(q[0]) + ' ' + F(q[1])).join('L') + 'Z';

function sevenSegmentPaths(value, { digitW = 20, digitH = 34, thick = 3.8, pitch = 26, y = 3 } = {}) {
  let lit = '', off = '';
  droCells(value).forEach((ch, i) => {
    const P = segmentPolys(i * pitch, y, digitW, digitH, thick), on = SEGMENTS[ch] || '';
    for (const k of 'abcdefg') { if (on.includes(k)) lit += poly(P[k]); else off += poly(P[k]); }
  });
  return { lit, off, dot: { cx: 3 * pitch + digitW + (pitch - digitW) / 2, cy: y + digitH - thick / 2, r: 2.3 } };
}
return {SEGMENTS,droCells,sevenSegmentPaths}})();
